
import React from 'react';
import { CreateFarmPriceInput } from '@/types/database/farm-prices';

interface FarmPricePreviewTableProps {
  preview: CreateFarmPriceInput[];
}

const FarmPricePreviewTable: React.FC<FarmPricePreviewTableProps> = ({ preview }) => {
  if (preview.length === 0) return null;

  return (
    <div>
      <h3 className="text-lg font-semibold mb-3">
        Preview ({preview.length} records)
      </h3>
      <div className="border rounded-lg overflow-hidden">
        <div className="max-h-60 overflow-y-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-2 text-left">Product</th>
                <th className="px-3 py-2 text-left">Region</th>
                <th className="px-3 py-2 text-left">Supplier</th>
                <th className="px-3 py-2 text-right">Farm Price</th>
                <th className="px-3 py-2 text-right">Total Price</th>
                <th className="px-3 py-2 text-left">Date</th>
              </tr>
            </thead>
            <tbody>
              {preview.slice(0, 10).map((price, index) => (
                <tr key={index} className="border-t">
                  <td className="px-3 py-2">{price.product_name}</td>
                  <td className="px-3 py-2">{price.region}</td>
                  <td className="px-3 py-2">{price.supplier_name || '-'}</td>
                  <td className="px-3 py-2 text-right">
                    ETB {price.farm_price_per_kg.toFixed(2)}
                  </td>
                  <td className="px-3 py-2 text-right">
                    ETB {price.price.toFixed(2)}
                  </td>
                  <td className="px-3 py-2">{price.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {preview.length > 10 && (
          <div className="px-3 py-2 bg-gray-50 text-sm text-gray-600">
            ... and {preview.length - 10} more records
          </div>
        )}
      </div>
    </div>
  );
};

export default FarmPricePreviewTable;
